import { render } from "./ViewStoreProfileContainer.vue?vue&type=template&id=48503c62"
import script from "./ViewStoreProfileContainer.vue?vue&type=script&lang=js"
export * from "./ViewStoreProfileContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__